(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aimp-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(bar) {
      if (!bar || bar.dataset.aimpStickyReady) return;
      bar.dataset.aimpStickyReady = 'true';

      var hero = document.querySelector('.aimp-hero .aimp-buy');
      // The bar stays hidden while any of these are on screen: the offer and
      // final CTA buttons, and the whole sample PDF viewer section.
      var others = Array.prototype.slice.call(
        document.querySelectorAll('#aimp-offer .aimp-buy, .aimp-final .aimp-buy, #aimp-sample')
      );
      var heroPast = false;
      var visibleOthers = 0;
      var seen = new Map();

      function update() {
        var show = heroPast && visibleOthers === 0;
        bar.classList.toggle('is-visible', show);
        bar.toggleAttribute('inert', !show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
      }

      if (!('IntersectionObserver' in window)) {
        heroPast = true;
        update();
        return;
      }

      if (hero) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            heroPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          });
          update();
        }).observe(hero);
      } else {
        var onScroll = function () {
          heroPast = window.scrollY > 500;
          update();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      if (others.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            seen.set(e.target, e.isIntersecting);
          });
          visibleOthers = 0;
          seen.forEach(function (isVisible) {
            if (isVisible) visibleOthers++;
          });
          update();
        });
        others.forEach(function (el) {
          io.observe(el);
        });
      }
    }

    function boot() {
      init(document.querySelector('[data-aimp-sticky]'));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mal-page"] && !Shopify.designMode) return;
  try {
    (function(){function init(){var b=document.querySelector('[data-mal-sticky]');if(!b||b.dataset.r)return;b.dataset.r='1';var h=document.querySelector('.mal-hero .mal-buy'),o=[].slice.call(document.querySelectorAll('#mal-invest,#mal-final')),past=false,n=0,m=new Map();function u(){var s=past&&n===0;b.classList.toggle('on',s);b.toggleAttribute('inert',!s);b.setAttribute('aria-hidden',s?'false':'true');document.body.style.paddingBottom=(s&&matchMedia('(max-width:749px)').matches)?b.offsetHeight+'px':''}if(!('IntersectionObserver' in window)){past=true;u();return}if(h)new IntersectionObserver(function(e){e.forEach(function(x){past=!x.isIntersecting&&x.boundingClientRect.top<0});u()}).observe(h);else{past=true}var io=new IntersectionObserver(function(e){e.forEach(function(x){m.set(x.target,x.isIntersecting)});n=0;m.forEach(function(v){if(v)n++});u()});o.forEach(function(el){io.observe(el)});u()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mal-terms"] && !Shopify.designMode) return;
  try {
    (function(){function open(){var d=document.querySelector('[data-mal-terms]');if(!d)return;d.open=true;var w=document.getElementById('mal-terms');if(w)w.scrollIntoView({behavior:'smooth',block:'start'})}function init(){var d=document.querySelector('[data-mal-terms]');if(!d||d.dataset.r)return;d.dataset.r='1';document.querySelectorAll('.mal a[href$="/policies/terms-of-service"]').forEach(function(a){a.setAttribute('href','#mal-terms');a.addEventListener('click',function(e){e.preventDefault();history.replaceState(null,'','#mal-terms');open()})});if(location.hash==='#mal-terms')d.open=true}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();window.addEventListener('hashchange',function(){if(location.hash==='#mal-terms')open()});document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();
})();
